import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { getApiErrorMessage } from "@/helpers/get-api-error-message";
import { inviteProfessionalToDashboard } from "../services/invite-professional-to-dashboard";

export function useInviteProfessionalToDashboard(professionalId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => inviteProfessionalToDashboard(professionalId),
    onSuccess: (data) => {
      // The professionals list caches for 30 minutes, and the open drawer is
      // fed from it — without this the panel would keep offering to invite
      // someone who has just been invited.
      queryClient.invalidateQueries({ queryKey: ["professionals"] });
      toast({
        title: "Invitation sent",
        description: `${data.email} can now set up their dashboard account.`,
      });
    },
    onError: (error: unknown) => {
      // The server's refusals are the useful message here — "already has
      // dashboard access", "has no email address" — so surface them verbatim.
      toast({
        title: getApiErrorMessage(error, "Failed to send the invitation"),
        variant: "destructive",
      });
    },
  });
}
